<div class="header">
  <ui-skeleton [uiTitle]="null" [uiParagraph]="{ rows: 1, width: '100%' }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-md' }" [uiActive]="true"></ui-skeleton>
</div>

<comment-skeleton></comment-skeleton>
